module.exports = __webpack_public_path__ + "img/parallax.5d58af56.svg";